"use client";

import Link from "next/link";
import Image from "next/image";
import { useState } from "react";
import type { MenuItem } from "@/lib/shopify/types";
import { site } from "@/lib/site";
import { Drawer } from "@/components/ui/Drawer";
import { CloseIcon, MenuIcon } from "@/components/ui/icons";

import Logo from "@/assets/dj_logo.png";

type Props = { primary: MenuItem[]; secondary: MenuItem[]; occasions: MenuItem[] };

export function MobileMenu({ primary, secondary, occasions }: Props) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <div className="lg:hidden">
      <button type="button" className="-m-2 p-2" onClick={() => setOpen(true)} aria-label="Open menu">
        <MenuIcon />
      </button>
      <Drawer open={open} onClose={close} label="Menu" side="left">
        <div className="flex h-full flex-col overflow-y-auto">
          <div className="flex items-center justify-between border-b border-paper/20 px-6 py-3">
            <Image src={Logo} height={32} alt={site.name} />
            <button type="button" onClick={close} className="-m-2 p-2" aria-label="Close menu">
              <CloseIcon />
            </button>
          </div>
          <nav aria-label="Mobile" className="px-6 py-6">
            <ul className="space-y-1">
              {primary.map((link) => (
                <li key={link.path}>
                  <Link href={link.path} onClick={close} className="block py-2 font-display text-[1.75rem] leading-tight transition-colors hover:text-gold">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
            {occasions.length ? (
              <>
                <h2 className="mt-8 font-serif text-lg italic">
                  <span className="gold-foil">Occasions</span>
                </h2>
                <ul className="mt-2">
                  {occasions.map((link) => (
                    <li key={link.path}>
                      <Link href={link.path} onClick={close} className="block py-1.5 text-lg transition-colors hover:text-gold">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
            <ul className="mt-8 border-t border-paper/20 pt-6">
              {[...secondary, { title: "Search", path: "/search" }].map(
                (link) => (
                  <li key={link.path}>
                    <Link href={link.path} onClick={close} className="block py-1.5 text-lg transition-colors hover:text-gold">
                      {link.title}
                    </Link>
                  </li>
                ),
              )}
            </ul>
          </nav>
        </div>
      </Drawer>
    </div>
  );
}
